__turbopack_context__.v({
  "align": "krails-invoice-rebate-module__crXNfq__align",
  "alignCopy": "krails-invoice-rebate-module__crXNfq__alignCopy",
  "alignCta": "krails-invoice-rebate-module__crXNfq__alignCta",
  "alignDash": "krails-invoice-rebate-module__crXNfq__alignDash",
  "alignInner": "krails-invoice-rebate-module__crXNfq__alignInner",
  "alignItem": "krails-invoice-rebate-module__crXNfq__alignItem",
  "alignList": "krails-invoice-rebate-module__crXNfq__alignList",
  "alignPhoto": "krails-invoice-rebate-module__crXNfq__alignPhoto",
  "alignTint": "krails-invoice-rebate-module__crXNfq__alignTint",
  "alignTitle": "krails-invoice-rebate-module__crXNfq__alignTitle",
  "beam": "krails-invoice-rebate-module__crXNfq__beam",
  "brandLtr": "krails-invoice-rebate-module__crXNfq__brandLtr",
  "card": "krails-invoice-rebate-module__crXNfq__card",
  "copy": "krails-invoice-rebate-module__crXNfq__copy",
  "featureBg": "krails-invoice-rebate-module__crXNfq__featureBg",
  "featureBody": "krails-invoice-rebate-module__crXNfq__featureBody",
  "featureCanvas": "krails-invoice-rebate-module__crXNfq__featureCanvas",
  "featureCard": "krails-invoice-rebate-module__crXNfq__featureCard",
  "featureContent": "krails-invoice-rebate-module__crXNfq__featureContent",
  "featureGrid": "krails-invoice-rebate-module__crXNfq__featureGrid",
  "featurePanel": "krails-invoice-rebate-module__crXNfq__featurePanel",
  "featureTitle": "krails-invoice-rebate-module__crXNfq__featureTitle",
  "icon": "krails-invoice-rebate-module__crXNfq__icon",
  "inner": "krails-invoice-rebate-module__crXNfq__inner",
  "krailsMark": "krails-invoice-rebate-module__crXNfq__krailsMark",
  "lede": "krails-invoice-rebate-module__crXNfq__lede",
  "node": "krails-invoice-rebate-module__crXNfq__node",
  "phoneCard": "krails-invoice-rebate-module__crXNfq__phoneCard",
  "rebate-beam-x": "krails-invoice-rebate-module__crXNfq__rebate-beam-x",
  "rebate-beam-y": "krails-invoice-rebate-module__crXNfq__rebate-beam-y",
  "section": "krails-invoice-rebate-module__crXNfq__section",
  "step": "krails-invoice-rebate-module__crXNfq__step",
  "stepBody": "krails-invoice-rebate-module__crXNfq__stepBody",
  "stepTitle": "krails-invoice-rebate-module__crXNfq__stepTitle",
  "stepper": "krails-invoice-rebate-module__crXNfq__stepper",
  "stepperWrap": "krails-invoice-rebate-module__crXNfq__stepperWrap",
  "track": "krails-invoice-rebate-module__crXNfq__track",
});
